import { IItem } from '@/type/Item';

function generateKey() {
	return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
}

export const items: IItem[] = [
	// {
	// 	name: 'Стандартный',
	// 	id: 'standart',
	// 	icon: 'unknown.svg',
	// 	tags: ['base'],
	// 	statsMod: [0, 0, 0],
	// 	perk: '',
	// },
	{
		name: 'Боец I',
		id: 'rifleman1',
		icon: 'rifleman.svg',
		tags: ['base'],
		statsMod: [1, 1, 1],
		perk: '+10.5% скорости уменьшения разброса после резкого разворота',
	},
	{
		name: 'Боец II',
		id: 'rifleman2',
		icon: 'rifleman.svg',
		tags: ['base'],
		statsMod: [2, 2, 2],
		perk: '+5.3% скорость спринта',
	},
	{
		name: 'Боец III',
		id: 'rifleman3',
		icon: 'rifleman.svg',
		tags: ['base'],
		statsMod: [3, 3, 3],
		perk: '+15% скорость использования аптечки',
	},
	{
		name: 'Медик',
		id: 'medic',
		icon: 'medic.svg',
		tags: ['base', 'medic'],
		statsMod: [1, 2, 0],
		perk: '+3.5% скорость бега',
	},
	{
		name: 'Штурмовик I',
		id: 'assaulter1',
		icon: 'assaulter.svg',
		tags: ['base'],
		statsMod: [2, 0, 1],
		perk: '+35% скорость залезания на объекты',
	},
	{
		name: 'Штурмовик II',
		id: 'assaulter2',
		icon: 'assaulter.svg',
		tags: ['base'],
		statsMod: [3, 1, 2],
		perk: '+35% выносливости',
	},
	{
		name: 'Штурмовик III',
		id: 'assaulter3',
		icon: 'assaulter.svg',
		tags: ['base'],
		statsMod: [4, 2, 3],
		perk: '+100% восстановления здоровья аптечкой',
	},
	{
		name: 'Штурмовик IV',
		id: 'assaulter4',
		icon: 'assaulter.svg',
		tags: ['base'],
		statsMod: [5, 3, 4],
		perk: '+12% скорость перезарядки ручного оружия',
	},
	{
		name: 'Партизан II',
		id: 'partisan2',
		icon: 'partisan.svg',
		tags: ['base'],
		statsMod: [5, 0, 3],
		perk: '+5.3% скорость спринта',
	},
	{
		name: 'Диверсант',
		id: 'saboteur',
		icon: 'saboteur.svg',
		tags: ['base'],
		statsMod: [5, 6, 4],
		perk: '+15% скорость спринта',
	},
	{
		name: 'Инженер I',
		id: 'engineer1',
		icon: 'engineer.svg',
		tags: ['base', 'engineer'],
		statsMod: [1, 2, 0],
		perk: '+21% скорость при движении лежа или в приседе',
	},
	{
		name: 'Инженер II',
		id: 'engineer2',
		icon: 'engineer.svg',
		tags: ['base', 'engineer'],
		statsMod: [2, 4, 0],
		perk: '+35% скорость восстановления выносливости',
	},
	{
		name: 'Снайпер I',
		id: 'sniper1',
		icon: 'sniper.svg',
		tags: ['base'],
		statsMod: [2, -2, 3],
		perk: '+14% максимальная высота прыжка',
	},
	{
		name: 'Снайпер II',
		id: 'sniper2',
		icon: 'sniper.svg',
		tags: ['base'],
		statsMod: [2, -2, 4],
		perk: '+35% времени задержки дыхания при прицеливании',
	},
	{
		name: 'Снайпер III',
		id: 'sniper3',
		icon: 'sniper.svg',
		tags: ['base'],
		statsMod: [2, -2, 6],
		perk: '+4.8% скорость перезарядки ручного оружия',
	},
	{
		name: 'Бронебойщик I',
		id: 'at1',
		icon: 'antitank.svg',
		tags: ['base'],
		statsMod: [-2, 2, 3],
		perk: '+52.5% скорость изменения положения тела',
	},
	{
		name: 'Бронебойщик II',
		id: 'at2',
		icon: 'antitank.svg',
		tags: ['base'],
		statsMod: [-2, 4, 4],
		perk: '+17.5% дальности броска гранат',
	},
	{
		name: 'Пулемётчик I',
		id: 'mg1',
		icon: 'mg.svg',
		tags: ['base'],
		statsMod: [0, 0, 3],
		perk: '+3.5% скорость бега',
	},
	{
		name: 'Пулемётчик II',
		id: 'mg2',
		icon: 'mg.svg',
		tags: ['base'],
		statsMod: [0, 0, 6],
		perk: '+7% скорость прицеливания из оружия',
	},
	{
		name: 'Пулемётчик III',
		id: 'mg3',
		icon: 'mg.svg',
		tags: ['base'],
		statsMod: [1, 2, 6],
		perk: '+100% восстановления здоровья аптечкой',
	},
	{
		name: 'Радист I',
		id: 'radio1',
		icon: 'radio.svg',
		tags: ['base'],
		statsMod: [5, 0, -2],
		perk: '+17.5% скорость смены оружия',
	},
	{
		name: 'Радист II',
		id: 'radio2',
		icon: 'radio.svg',
		tags: ['base'],
		statsMod: [6, 2, -2],
		perk: '+70% восстановления здоровья аптечкой',
	},
	{
		name: 'Миномётчик',
		id: 'mortar',
		icon: 'mortar.svg',
		tags: ['base', 'mortar'],
		statsMod: [-1, 2, 2],
		perk: '-17.5% эффект тряски головы, вызванный близкими взрывами',
	},
	{
		name: 'Огнемётчик I',
		id: 'flamethrower1',
		icon: 'flamethrower.svg',
		tags: ['base', 'flamethrower'],
		statsMod: [2, 5, -1],
		perk: '+28% стабильности прицела ручного оружия при получении повреждений',
	},
	{
		name: 'Огнемётчик II',
		id: 'flamethrower2',
		icon: 'flamethrower.svg',
		tags: ['base', 'flamethrower'],
		statsMod: [2, 7, 0],
		perk: '+12.3% живучести',
	},
	{
		name: 'Пилот-истр. I',
		id: 'pilot-fighter1',
		icon: 'pilot-fighter.svg',
		tags: ['pilot'],
		statsMod: [0, 2, 1],
		perk: '+5% скорость восстановления лётной выносливости',
	},
	{
		name: 'Пилот-истр. II',
		id: 'pilot-fighter2',
		icon: 'pilot-fighter.svg',
		tags: ['pilot'],
		statsMod: [1, 3, 2],
		perk: '+5% лётной выносливости',
	},
	{
		name: 'Пилот-истр. III',
		id: 'pilot-fighter3',
		icon: 'pilot-fighter.svg',
		tags: ['pilot'],
		statsMod: [1, 5, 3],
		perk: '-10% эффект потери контроля при наступлении блэкаута при перегрузках',
	},
	{
		name: 'Пилот-штурм. I',
		id: 'pilot-attacker1',
		icon: 'pilot-attacker.svg',
		tags: ['pilot'],
		statsMod: [0, 1, 2],
		perk: '-5% эффект потери контроля при наступлении блэкаута при перегрузках',
	},
	{
		name: 'Пилот-штурм. II',
		id: 'pilot-attacker2',
		icon: 'pilot-attacker.svg',
		tags: ['pilot'],
		statsMod: [1, 2, 3],
		perk: '+10% угол сфокусированного и периферийного зрения',
	},
	{
		name: 'Пилот-штурм. III',
		id: 'pilot-attacker3',
		icon: 'pilot-attacker.svg',
		tags: ['pilot'],
		statsMod: [1, 3, 5],
		perk: '+21% лётной выносливости',
	},
	{
		name: 'Танкист I',
		id: 'tank1',
		icon: 'tank.svg',
		tags: ['crew', 'tank'],
		statsMod: [3, -2, 2],
		perk: '+10% скорость посадки, выхода и смены места в технике',
	},
	{
		name: 'Танкист II',
		id: 'tank2',
		icon: 'tank.svg',
		tags: ['crew', 'tank'],
		statsMod: [5, -2, 3],
		perk: '+7.5% скорость починки техники',
	},
	{
		name: 'Танкист III',
		id: 'tank3',
		icon: 'tank.svg',
		tags: ['crew', 'tank'],
		statsMod: [7, -2, 4],
		perk: '+45% скорость переключения передач (навык водителя)',
	},
	{
		name: 'Мотоциклист I',
		id: 'moto1',
		icon: 'moto.svg',
		tags: ['recon-crew', 'motorcycle'],
		statsMod: [2, 0, 4],
		perk: '+7% скорость починки техники',
	},
	{
		name: 'Водитель БТР',
		id: 'apc-driver',
		icon: 'apc-driver.svg',
		tags: ['recon-crew', 'apc-driver'],
		statsMod: [4, 0, 2],
		perk: '+35% скорость переключения передач (навык водителя)',
	},
];

export const uniqueSoldiersList = [
	{
		name: 'Боец',
		icon: 'rifleman.svg',
		tags: ['base'],
	},
	{
		name: 'Медик',
		icon: 'medic.svg',
		tags: ['base', 'medic'],
	},
	{
		name: 'Штурмовик',
		icon: 'assaulter.svg',
		tags: ['base'],
	},
	{
		name: 'Партизан',
		icon: 'partisan.svg',
		tags: ['base'],
	},
	{
		name: 'Инженер',
		icon: 'engineer.svg',
		tags: ['base', 'engineer'],
	},
	{
		name: 'Снайпер',
		icon: 'sniper.svg',
		tags: ['base'],
	},
	{
		name: 'Бронебойщик',
		icon: 'antitank.svg',
		tags: ['base'],
	},
	{
		name: 'Пулемётчик',
		icon: 'mg.svg',
		tags: ['base'],
	},
	{
		name: 'Радист',
		icon: 'radio.svg',
		tags: ['base'],
	},
	{
		name: 'Миномётчик',
		icon: 'mortar.svg',
		tags: ['base', 'mortar'],
	},
	{
		name: 'Огнемётчик',
		icon: 'flamethrower.svg',
		tags: ['base', 'flamethrower'],
	},
	{
		name: 'Пилот',
		icon: 'pilot-fighter.svg',
		tags: ['pilot'],
	},
	{
		name: 'Танкист',
		icon: 'tank.svg',
		tags: ['crew', 'tank'],
	},
	{
		name: 'Мотоциклист',
		icon: 'moto.svg',
		tags: ['recon-crew', 'motorcycle'],
	},
	{
		name: 'Водитель БТР',
		icon: 'apc-driver.svg',
		tags: ['recon-crew', 'apc-driver'],
	},
];
